import React from 'react'
import Professionals from '../fetures/professionals/Professionals'

const ProfessionalsPage = () => {
  return (
    <Professionals/>
  )
}

export default ProfessionalsPage